module.exports = __webpack_public_path__ + "img/jh.887f3e45.jpg";